import React, { useState } from 'react';
import { Search, MapPin, GraduationCap, MessageCircle } from 'lucide-react';
import { useApp } from '../context/AppContext';
import './TalentePage.css';

const MOCK_TALENTS = [
  { id: 1, name: 'Lena K.', age: 19, location: 'Kaiserslautern', education: 'Abitur', skills: ['HTML', 'CSS', 'Design'], bio: 'Kreative Webdesignerin mit Passion für moderne UI/UX.', availability: 'Sofort' },
  { id: 2, name: 'Noah B.', age: 22, location: 'Ludwigshafen', education: 'Berufsausbildung', skills: ['Social Media', 'Content', 'TikTok'], bio: 'Social-Media-Enthusiast mit nachgewiesenen Erfolgen.', availability: 'In 1 Monat' },
  { id: 3, name: 'Sara M.', age: 17, location: 'Speyer', education: 'Noch in der Schule', skills: ['Gastronomie', 'Service', 'Teamarbeit'], bio: 'Motivierte Schülerin mit Erfahrung im Gastgewerbe.', availability: 'Sofort' },
  { id: 4, name: 'Tim R.', age: 20, location: 'Worms', education: 'Mittlere Reife', skills: ['Logistik', 'Gabelstapler', 'Excel'], bio: 'Zuverlässiger Lagermitarbeiter mit 2 Jahren Erfahrung.', availability: 'Flexibel' },
];

export default function TalentePage() {
  const { user, openAuth } = useApp();
  const [query, setQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState('Alle');

  const filters = ['Alle', 'Sofort', 'Teilzeit', 'Vollzeit'];

  const filtered = MOCK_TALENTS.filter(t => {
    const q = query.toLowerCase();
    const matchQuery = !query
      || t.name.toLowerCase().includes(q)
      || t.skills.some(s => s.toLowerCase().includes(q))
      || t.location.toLowerCase().includes(q);
    const matchFilter = activeFilter === 'Alle' || t.availability === activeFilter;
    return matchQuery && matchFilter;
  });

  if (!user) {
    return (
      <div className="talente-gate">
        <div className="talente-gate__content">
          <div className="talente-gate__icon">👥</div>
          <h2>Talente entdecken</h2>
          <p>Melde dich an, um motivierte Jugendliche zu finden.</p>
          <button className="talente-gate__btn" onClick={() => openAuth('login')}>
            Anmelden
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="talente-page">
      {/* Header */}
      <div className="talente-header">
        <h1>Talente</h1>
        <p className="talente-header__sub">Finde motivierte Jugendliche</p>

        <div className="talente-search-bar">
          <Search size={17} className="talente-search-icon" />
          <input
            type="search"
            placeholder="Name, Fähigkeit oder Ort..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            className="talente-search-input"
          />
        </div>

        <div className="talente-filters">
          {filters.map(f => (
            <button
              key={f}
              className={`talente-filter-chip${activeFilter === f ? ' talente-filter-chip--active' : ''}`}
              onClick={() => setActiveFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      {/* Talent cards */}
      <div className="talente-list">
        {filtered.length === 0 && (
          <div className="talente-empty">
            <div>🔍</div>
            <h3>Keine Talente gefunden</h3>
            <p>Passe deine Suche an.</p>
          </div>
        )}
        {filtered.map(talent => (
          <div key={talent.id} className="talente-card">
            <div className="talente-card__avatar">
              {talent.name.slice(0, 2).toUpperCase()}
            </div>
            <div className="talente-card__info">
              <div className="talente-card__header">
                <div>
                  <h3 className="talente-card__name">{talent.name}, {talent.age}</h3>
                  <div className="talente-card__meta">
                    <span><MapPin size={12} /> {talent.location}</span>
                    <span><GraduationCap size={12} /> {talent.education}</span>
                  </div>
                </div>
                <span className={`talente-availability talente-availability--${talent.availability === 'Sofort' ? 'now' : 'later'}`}>
                  {talent.availability}
                </span>
              </div>
              <p className="talente-card__bio">{talent.bio}</p>
              <div className="talente-card__skills">
                {talent.skills.map(s => (
                  <span key={s} className="talente-skill-tag">{s}</span>
                ))}
              </div>
              <button className="talente-card__contact">
                <MessageCircle size={15} /> Kontakt aufnehmen
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="talente-note">
        Vollständige Talent-Suche wird in Kürze verfügbar.
      </div>
    </div>
  );
}
